export const buildForm = user => ({
  id: user,
  first_name: user.first_name,
  last_name: user.last_name,
  email: user.email,
  locale: user.locale,
  time_zone: user.time_zone,
})
